import { NgIf, NgTemplateOutlet, NgFor, AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { SiteContextSelectorComponent, IconComponent } from '@spartacus/storefront'
import { combineLatest, Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { EbBaseSiteService } from '../services/eb-base-site.service'
import { EbCountryService } from '../services/eb-country.service'
import { EbLanguageService } from '../services/eb-language.service'
import { EbSiteContextComponentService } from '../services/eb-site-context-component.service'

@Component({
  selector: 'eb-site-context-selector',
  templateUrl: './eb-site-context-selector.component.html',
  styleUrls: ['./eb-site-context-selector.component.scss'],
  imports: [NgIf, IconComponent, NgTemplateOutlet, NgFor, AsyncPipe]
})
export class EbSiteContextSelectorComponent extends SiteContextSelectorComponent {
  constructor(
    protected ebSiteContextComponentService: EbSiteContextComponentService,
    protected ebBaseSiteService: EbBaseSiteService,
    protected ebLanguageService: EbLanguageService,
    protected ebCountryService: EbCountryService
  ) {
    super(ebSiteContextComponentService)
  }

  toggleDialog() {
    this.ebSiteContextComponentService
      .getContextSelectionDialogVisibility()
      .pipe(
        take(1),
        map(isVisible =>
          this.ebSiteContextComponentService.setContextSelectionDialogVisibility(!isVisible)
        )
      )
      .subscribe()
  }

  get context$(): Observable<any> {
    return combineLatest([
      this.ebBaseSiteService.getActive(),
      this.ebSiteContextComponentService.getItems(),
      this.ebLanguageService.getActive()
    ]).pipe(
      map(([activeBaseSite, contextItems]) => {
        const activeContext = contextItems.find(contextItem => contextItem.uid === activeBaseSite)
        return {
          activeContext,
          contextItems
        }
      })
    )
  }

  get activeLanguage$(): Observable<string> {
    return this.ebLanguageService.getActive()
  }

  setActiveContext(activatedContext, activatedLanguage) {
    this.ebCountryService
      .getActive()
      .pipe(take(1))
      .subscribe(activeCountry => {
        if (activeCountry !== activatedContext.country.isocode) {
          this.ebCountryService.setActive(activatedContext.country.isocode)
        }
      })
    this.ebLanguageService.setActive(activatedLanguage)
  }
}
